// components/cards/BaseCard.jsx
const BaseCard = ({ 
    children, 
    className = "", 
    bgColor = "", 
    borderColor = "border-gray-200",
    padding = "p-6",
    rounded = "rounded-lg"
  }) => (
    <div className={`${bgColor} border ${borderColor} ${rounded} ${padding} ${className}`}>
      {children}
    </div>
  );

export default BaseCard;